export const ITR_updatePreviousScreenReducer = {
  ITR_updatePreviousScreen: (state, action) => {
    state.previousScreen = action.payload;
  },
};
